import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MsalGuard } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';

/**
 * Auth guard that checks if user is authenticated via MSAL
 * Redirects to login if not authenticated
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private readonly msalGuard = inject(MsalGuard);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (environment.noAuthMode) {
      return true;
    }
    return this.msalGuard.canActivate(route, state);
  }
}
